import { combineReducers } from 'redux';
import { PromotionCodeAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { PromotionCode } from '../../../../types/items';
import {
  createPromotionCodeFail,
  createPromotionCodeRequest,
  createPromotionCodeSuccess,
  getPromotionCodeFail,
  getPromotionCodeListRequest,
  getPromotionCodeRequest,
  getPromotionCodeSuccess,
  initPromotionCodeFail,
  initPromotionCodeRequest,
  initPromotionCodeSuccess,
  resetCurrentPromotionCode,
  savePromotionCodeFail,
  savePromotionCodeRequest,
  savePromotionCodeSuccess,
} from '../actions';
//
type State = Loadable<PromotionCode>;
type ReducerOf<T extends keyof State> = Reducer<State, PromotionCodeAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case resetCurrentPromotionCode.type:
    case getPromotionCodeListRequest.type:
    case initPromotionCodeRequest.type:
      return null;

    case getPromotionCodeSuccess.type:
    case createPromotionCodeSuccess.type:
    case savePromotionCodeSuccess.type:
    case initPromotionCodeSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getPromotionCodeRequest.type:
    case createPromotionCodeRequest.type:
    case savePromotionCodeRequest.type:
    case initPromotionCodeRequest.type:
      return true;

    case getPromotionCodeSuccess.type:
    case getPromotionCodeFail.type:
    case createPromotionCodeSuccess.type:
    case createPromotionCodeFail.type:
    case savePromotionCodeSuccess.type:
    case savePromotionCodeFail.type:
    case initPromotionCodeSuccess.type:
    case initPromotionCodeFail.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<State>({
  data,
  loading,
});
